import { render, staticRenderFns } from "./AgentPlazaContent.vue?vue&type=template&id=85395c68&scoped=true"
import script from "./AgentPlazaContent.vue?vue&type=script&lang=js"
export * from "./AgentPlazaContent.vue?vue&type=script&lang=js"
import style0 from "./AgentPlazaContent.vue?vue&type=style&index=0&id=85395c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85395c68",
  null
  
)

export default component.exports